import { FilterChip, FilterContainer } from "./ComparePlans.styles";
import { IComparePlansFilter } from "./types";

interface FilterTabsProps {
  filters: IComparePlansFilter[];
  activeFilter: string;
  onFilterChange: (value: string) => void;
}

const FilterTabs = ({
  filters,
  activeFilter,
  onFilterChange,
}: FilterTabsProps) => {
  if (!filters.length) return null;

  return (
    <FilterContainer>
      {filters.map((filter) => (
        <FilterChip
          key={filter.value}
          $active={activeFilter === filter.value}
          onClick={() => onFilterChange(filter.value)}
          aria-pressed={activeFilter === filter.value}
        >
          {filter.label}
        </FilterChip>
      ))}
    </FilterContainer>
  );
};

export default FilterTabs;
